// AUTO-GENERATED by tools/generate-parallel.mjs --world 13. Do not edit by hand.
// Regenerate with: node tools/generate-parallel.mjs --world 13
// W13 (Crucible) — third expansion. Mixer tiles: colorless until claimed.
// // Slid tile that bumps a mixer claims it for that color permanently.
import type { LevelDef } from '@tessera/engine';

export const WORLD_13_GENERATED: LevelDef[] = [
  // d*=6  branching=10.68  D=0.009  tiles=13
  {
    id: 'w13-l01',
    world: 13,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0, state: { kind: 'mixer' } },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 2 },
    { coord: { q: -3, r: 1 }, color: 2 },
    { coord: { q: 3, r: 0 }, color: 3 },
    { coord: { q: -1, r: -2 }, color: 3, state: { kind: 'mixer' } },
    ],
  },
  // d*=6  branching=16.53  D=0.106  tiles=12
  {
    id: 'w13-l02',
    world: 13,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -1, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 2 },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'mixer' } },
    { coord: { q: -1, r: 3 }, color: 3 },
    { coord: { q: -2, r: 3 }, color: 3 },
    ],
  },
  // d*=6  branching=18.70  D=0.110  tiles=12
  {
    id: 'w13-l03',
    world: 13,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 0, state: { kind: 'mixer' } },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -2, r: -1 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 2 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: -1, r: 3 }, color: 3 },
    { coord: { q: 0, r: 3 }, color: 3 },
    ],
  },
  // d*=7  branching=13.03  D=0.367  tiles=13
  {
    id: 'w13-l04',
    world: 13,
    index: 4,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -3, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 2 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: -3, r: 1 }, color: 1, state: { kind: 'mixer' } },
    { coord: { q: 2, r: 1 }, color: 2 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: -3, r: 0 }, color: 3, state: { kind: 'mixer' } },
    { coord: { q: -2, r: -1 }, color: 3 },
    ],
  },
  // d*=7  branching=14.68  D=0.373  tiles=14
  {
    id: 'w13-l05',
    world: 13,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0, state: { kind: 'mixer' } },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 2 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 3 },
    { coord: { q: -2, r: 3 }, color: 3 },
    ],
  },
  // d*=7  branching=15.69  D=0.377  tiles=12
  {
    id: 'w13-l06',
    world: 13,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -3, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: -2, r: -1 }, color: 2 },
    { coord: { q: -1, r: -2 }, color: 2 },
    { coord: { q: 3, r: 0 }, color: 3 },
    { coord: { q: 0, r: 3 }, color: 3, state: { kind: 'mixer' } },
    ],
  },
  // d*=7  branching=17.33  D=0.412  tiles=14
  {
    id: 'w13-l07',
    world: 13,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 0, state: { kind: 'mixer' } },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 2, state: { kind: 'mixer' } },
    { coord: { q: -3, r: 1 }, color: 3 },
    { coord: { q: -3, r: 3 }, color: 3 },
    ],
  },
  // d*=7  branching=21.49  D=0.456  tiles=12
  {
    id: 'w13-l08',
    world: 13,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 0, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'mixer' } },
    { coord: { q: -1, r: -2 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 3 },
    { coord: { q: -3, r: 1 }, color: 3 },
    ],
  },
  // d*=7  branching=18.04  D=0.474  tiles=12
  {
    id: 'w13-l09',
    world: 13,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'mixer' } },
    { coord: { q: -2, r: -1 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: 2, r: 1 }, color: 3 },
    { coord: { q: 1, r: 2 }, color: 3 },
    ],
  },
  // d*=7  branching=24.18  D=0.496  tiles=14
  {
    id: 'w13-l10',
    world: 13,
    index: 10,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: 2, r: 1 }, color: 0, state: { kind: 'mixer' } },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -3, r: 1 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: -1, r: -2 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 3 },
    { coord: { q: 3, r: 0 }, color: 3 },
    ],
  },
];
